import { useMediaQuery } from '../../utils/breakpoints/breakpoints';

import DateRangeFilter from './DateRangeFilter';
import DateRangeFilterMobile from './DateRangeFilterMobile';

const DateRangeFilterComponent = ({ onFlexibleOptionsChange, ...props }) => {
  const { isBiggerThanTablet } = useMediaQuery();

  if (isBiggerThanTablet()) {
    return <DateRangeFilter {...props} />;
  }

  return (
    <DateRangeFilterMobile
      {...props}
      onFlexibleOptionsChange={onFlexibleOptionsChange}
    />
  );
};

export default DateRangeFilterComponent;
